module.exports = __webpack_public_path__ + "static/media/just-beans-half-opacity.cad567fc.png";